export const createGetCommentGenerationTemplatesRequest = () => {
  return {
    url: "/comments_generation_templates",
    method: "GET",
  };
};

export const createCustomPromptRequest = (content, custom_prompt, post_author_name = null) => {
  return {
    url: "/ai/custom_prompt",
    method: "POST",
    data: {
      comment_generation: true,
      post_author_name,
      custom_prompt: `<Post content start >${content}<Post content end >\n  ${custom_prompt}`,
    },
  };
};
